import React, { useState, useEffect } from 'react';

export interface CartItem {
    id: number;
    name: string;
    price: number;
    qty: number;
    image: string;
    category?: string;
}

const STORAGE_KEY = 'petcare_cart';

export const getCartFromStorage = (): CartItem[] => {
    try {
        const data = localStorage.getItem(STORAGE_KEY);
        return data ? JSON.parse(data) : [];
    } catch {
        return [];
    }
};

export const saveCartToStorage = (items: CartItem[]): void => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
};

export const clearCartStorage = (): void => {
    localStorage.removeItem(STORAGE_KEY);
};
